import { createSlice } from '@reduxjs/toolkit';

// todo: need to remove once api is done
const reducerName = 'atsJobCreate';
const initialState = {
  currentJob: {
    isLoading: true,
    data: {},
    status: undefined,
    error: undefined,
  },
  hiringTeam: {
    isLoading: true,
    data: {},
    status: undefined,
    error: undefined,
  },
  updatedHiringTeam: {
    isLoading: true,
    data: {},
    status: undefined,
    error: undefined,
  },
  getOffices: {
    isLoading: true,
    data: [],
    status: undefined,
    error: undefined,
  },
  getJobPost: {
    isLoading: true,
    data: [],
    status: undefined,
    error: undefined,
  },
  defaultJobPost: {
    isLoading: false,
    data: [],
    status: undefined,
    error: undefined,
  },
  formTemplateOptions: {
    isLoading: false,
    data: [],
    status: undefined,
    error: undefined,
  },
  getInterviewPlan: {
    isLoading: true,
    data: [],
    status: undefined,
    error: undefined,
  },
  getInterviewPools: {
    isLoading: true,
    data: [],
    status: undefined,
    error: undefined,
  },
  getHackerrankStatus: {
    isLoading: true,
    data: [],
    status: undefined,
    error: undefined,
  },
};

const { reducer, actions: atsJobCreateActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    applyFilter: (state, { payload: { dynamicID, type, value } }) => {
      if (!state.filters[dynamicID]) {
        state.filters[dynamicID] = {}; // Ensure the dynamic ID exists
      }
      state.filters[dynamicID][type] = value;
      if (state.page && state.page[dynamicID]) {
        state.page[dynamicID].number = 0;
      }
    },

    applyStatusFilter: (state, { payload }) => {
      const newState = { ...state, statusFilter: payload };
      if (newState.page) {
        newState.page = { ...newState.page };
        Object.keys(newState.page).forEach((dynamicID) => {
          newState.page[dynamicID] = { ...newState.page[dynamicID], number: 0 };
        });
      }

      return newState;
    },

    clearData: (state) => {
      state.currentProjectProspects.data = {};
      state.currentProjectProspects.isLoading = true;
      state.currentProject.data = {};
      state.currentProject.isLoading = true;
    },

    setLoadingState: (state, { payload }) => {
      const { key, isLoading } = payload || {};
      if (state[key]) {
        state[key].isLoading = isLoading;
      }
    },

    setApiData: (state, { payload }) => {
      const { key, data, status, error, isLoading } = payload || {};
      if (state[key]) {
        state[key].data = data;
        state[key].isLoading = isLoading;
        state[key].status = status;
        if (error) {
          state[key].error = error;
        }
      }
    },
  },
});

export { atsJobCreateActions };
export default reducer;
